export default __webpack_public_path__ + "public/images/services/Mortgage@2x.png?67514bc0";